import React, { useEffect, useState } from 'react';
import { Box, Button, ButtonAsync, ButtonText, Checkbox, CheckboxIcon, CheckboxIndicator, CheckboxLabel, CheckIcon, FormControl, FormControlError, FormControlErrorText, FormControlLabel, FormControlLabelText, Heading, HStack, Input, InputField, Text, VStack, } from '../../primitives/index';
import { useAuth } from '../../../hooks';
import { useRoutingLib } from '../../../hooks/useRoutingLib';
import AsyncStorage from '@react-native-async-storage/async-storage';
export const LoginPrompt = ({}) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [pending, setPending] = useState(false);
    const [errors, setErrors] = useState({
        username: null,
        password: null,
    });
    const { login, user } = useAuth();
    const { Navigate, useNavigate } = useRoutingLib();
    const navigate = useNavigate();
    const getRememberedEmployeeNumber = async () => {
        try {
            const employeeNumber = await AsyncStorage.getItem('centralspecialties.employeeNumber');
            console.log('## HERE I AM GET THE REMEMBERED EMPLOYEE', employeeNumber);
            if (employeeNumber !== null) {
                setUsername(employeeNumber);
            }
        }
        catch (e) {
            console.log('Error retrieving employee number: ', e);
        }
    };
    const handleRememberMe = async () => {
        const toggle = !rememberMe;
        setRememberMe(toggle);
        if (toggle) {
            await AsyncStorage.setItem('auth.rememberMe', 'true');
        }
        else {
            await AsyncStorage.removeItem('auth.rememberMe');
        }
    };
    const onForgotPassword = () => navigate('/auth/forgot-password');
    const onChange = (field) => (val) => {
        const setValueState = field === 'password' ? setPassword : setUsername;
        setValueState(val);
        setErrors({ username: null, password: null });
    };
    const onPressLogin = async () => {
        if (!password || !username) {
            setErrors({
                password: !password ? 'Empty field' : null,
                username: !username ? 'Empty field' : null,
            });
            return;
        }
        try {
            setPending(true);
            await login(username, password, rememberMe);
        }
        catch (error) {
            setErrors({
                username: 'Incorrect username',
                password: 'Incorrect password',
            });
        }
        finally {
            setPending(false);
        }
    };
    useEffect(() => {
        const checkRememberMe = async () => {
            const userCheck = await AsyncStorage.getItem('auth.rememberMe');
            console.log('## HERE I AM checkRememberMe', userCheck);
            console.log('## HERE I AM user', user);
            if (userCheck) {
                await getRememberedEmployeeNumber();
                setRememberMe(true);
            }
        };
        checkRememberMe();
    }, []);
    if (user !== null) {
        return React.createElement(Navigate, { to: "/" });
    }
    return (React.createElement(Box, { sx: {
            _web: { w: '$92' },
            _ios: { w: '$full' },
            _android: { w: '$full' },
        }, alignSelf: "center" },
        React.createElement(VStack, { alignItems: "center", space: "xl" },
            React.createElement(Heading, { size: "xl" }, "Sign In"),
            React.createElement(FormControl, { size: "lg", width: "$full", isInvalid: errors.username !== null },
                React.createElement(FormControlLabel, null,
                    React.createElement(FormControlLabelText, null, "Username")),
                React.createElement(Input, { size: "lg", isDisabled: pending },
                    React.createElement(InputField, { value: username, onChangeText: onChange('username'), autoComplete: "username", autoCapitalize: "none", type: "text", placeholder: "Username" })),
                React.createElement(FormControlError, null,
                    React.createElement(FormControlErrorText, null, errors.username))),
            React.createElement(VStack, { w: "$full", space: "sm" },
                React.createElement(FormControl, { size: "lg", width: "$full", isInvalid: errors.password !== null },
                    React.createElement(FormControlLabel, null,
                        React.createElement(FormControlLabelText, null, "Password")),
                    React.createElement(Input, { size: "lg", isDisabled: pending },
                        React.createElement(InputField, { value: password, onChangeText: onChange('password'), autoComplete: "current-password", autoCapitalize: "none", type: "password", placeholder: "********" })),
                    React.createElement(FormControlError, null,
                        React.createElement(FormControlErrorText, null, errors.password))),
                React.createElement(HStack, { width: "$full", alignItems: "flex-end", justifyContent: "flex-end" },
                    React.createElement(Button, { onPress: onForgotPassword, size: "md", variant: "link", p: 0 },
                        React.createElement(ButtonText, { p: 0, m: 0, bold: true }, "Forgot Password")))),
            React.createElement(VStack, null,
                React.createElement(Text, null, " ")),
            React.createElement(VStack, { alignItems: "center", space: "md" },
                React.createElement(Checkbox, { "aria-label": "Remember me", value: "Remember me", isChecked: rememberMe, onChange: handleRememberMe, size: "lg" },
                    React.createElement(CheckboxIndicator, { mr: "$2" },
                        React.createElement(CheckboxIcon, { as: CheckIcon })),
                    React.createElement(CheckboxLabel, null, "Remember me")),
                React.createElement(ButtonAsync, { pending: pending, onPress: onPressLogin, w: "$40", size: "lg" },
                    React.createElement(ButtonText, null, "Sign in"))))));
};
